function getOffers() {

    return [...document.querySelectorAll('[data-offer-type]')]
}

function getButtons() {

    return [...document.querySelectorAll('[data-select-offer-type]')]
}

function getEnquiryForms() {
    return document.querySelectorAll('.offerHero__enquiryForm form')
}

function selectOffer(button) {
    const buttons = getButtons();
    const offers = getOffers();
    const offerType = button.getAttribute('data-select-offer-type');
    const offerEnquiryType = button.getAttribute('data-enquiry-offer-type')

    let offer;

    if (offerType) {
        offer = offers.find(o => o.getAttribute('data-offer-type') === offerType);
    }

    if (offer) {
        offer.classList.add('offerHero__offer--visible');
        offers.filter(o => o.getAttribute('data-offer-type') !== offerType)
              .forEach(o => o.classList.remove('offerHero__offer--visible'));

        button.classList.add('offerHero__offerSelectButton--selected');
        buttons.filter(b => b !== button)
               .forEach(b => b.classList.remove('offerHero__offerSelectButton--selected'));

        if (offerEnquiryType) {
            setEnquiryType(offerEnquiryType)
        }
    }
}

function setEnquiryType(value) {
    const forms = getEnquiryForms()

    forms.forEach((f) => {
        // hijack the model param as it isn't fulfilled for CMS pages
        const offerPriceTypeInput = f.querySelector('input[name=model]')


        if (offerPriceTypeInput) {
            const [type] = offerPriceTypeInput.value.split('-')
            offerPriceTypeInput.value = `${type.trim()} - ${value}`
        }
    })
}

function init() {
    const buttons = getButtons();

    buttons.forEach(button => button.addEventListener('click', () => selectOffer(button)));
}

$(document).ready(init);
